import Amount from './components/Amount'
import Display from './components/Display'
import DisplayLabel from './components/DisplayLabel'
import Rating from './components/Rating'

const Pricing = {
  Amount,
  Display,
  Rating,
  DisplayLabel,
}

export default Pricing
